import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import ConnectedFormControl from '../FormControl/FormControl.js';

const PhoneNumber = (_param)=> {
    var { label , errorMessage  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "label",
        "errorMessage"
    ]);
    return React.createElement(ConnectedFormControl, swcHelpers.extends({}, ConnectedFormControl.defaultProps, {
        id: "phone",
        "data-t": "phone-number",
        type: "tel",
        label: label,
        errorMessage: errorMessage
    }, rest));
};

export { PhoneNumber as default };
//# sourceMappingURL=PhoneNumber.js.map
